/**
 * fiko-komut.registry.ts — Tüm komutların veri-odaklı kataloğu.
 * Yeni komut = buraya bir nesne ekle (pencere + ribbon otomatik destekler).
 */
import { IKomutTanim } from './fiko-komut.tanim';
import { YAZI_FONTLARI } from './fiko-yazi3d';

export const FIKO_KOMUTLAR: IKomutTanim[] = [
  {
    id: 'yazi3d', etiket: '3D Yazı', ikon: 'font', workbench: 'part',
    parametreler: [
      { anahtar: 'metin', etiket: 'Metin', tip: 'metin', varsayilan: 'FikoYT' },
      { anahtar: 'fontAd', etiket: 'Font', tip: 'secim', varsayilan: 'helvetiker', secenekler: YAZI_FONTLARI.map(f => ({ deger: f.id, etiket: f.ad })) },
      { anahtar: 'boyut', etiket: 'Boyut', tip: 'mesafe', varsayilan: 10, birim: 'mm', min: 1, max: 500, adim: 1 },
      { anahtar: 'param', etiket: 'Kalınlık', tip: 'mesafe', varsayilan: 4, birim: 'mm', min: 0.1, max: 200, adim: 0.5 },
      { anahtar: 'harfBosluk', etiket: 'Harf Aralığı', tip: 'mesafe', varsayilan: 0, birim: 'mm', min: 0, max: 100, adim: 0.5 },
    ],
  },
  {
    id: 'kutu', etiket: 'Kutu (Box)', ikon: 'cube', workbench: 'part',
    parametreler: [
      { anahtar: 'pEn', etiket: 'En', tip: 'mesafe', varsayilan: 40, birim: 'mm', min: 0.1, adim: 1 },
      { anahtar: 'pBoy', etiket: 'Boy', tip: 'mesafe', varsayilan: 40, birim: 'mm', min: 0.1, adim: 1 },
      { anahtar: 'pYuk', etiket: 'Yükseklik', tip: 'mesafe', varsayilan: 30, birim: 'mm', min: 0.1, adim: 1 },
      { anahtar: 'ekleme', etiket: 'Birleştir / Çıkar', tip: 'boolean', varsayilan: true },
    ],
  },
  {
    id: 'silindir', etiket: 'Silindir / Delik', ikon: 'circle', workbench: 'part',
    parametreler: [
      { anahtar: 'pCap', etiket: 'Çap', tip: 'mesafe', varsayilan: 30, birim: 'mm', min: 0.1, adim: 1 },
      { anahtar: 'pYuk', etiket: 'Yükseklik', tip: 'mesafe', varsayilan: 40, birim: 'mm', min: 0.1, adim: 1 },
      { anahtar: 'ekleme', etiket: 'Birleştir / Çıkar (Delik)', tip: 'boolean', varsayilan: true },
    ],
  },
  {
    id: 'kure', etiket: 'Küre', ikon: 'globe', workbench: 'part',
    parametreler: [{ anahtar: 'pCap', etiket: 'Çap', tip: 'mesafe', varsayilan: 40, birim: 'mm', min: 0.1, adim: 1 }],
  },
  {
    id: 'koni', etiket: 'Koni', ikon: 'play', workbench: 'part',
    parametreler: [
      { anahtar: 'pCap', etiket: 'Taban Çapı', tip: 'mesafe', varsayilan: 40, birim: 'mm', min: 0.1, adim: 1 },
      { anahtar: 'pYuk', etiket: 'Yükseklik', tip: 'mesafe', varsayilan: 50, birim: 'mm', min: 0.1, adim: 1 },
    ],
  },
  {
    id: 'torus', etiket: 'Torus (Simit)', ikon: 'circle notch', workbench: 'part',
    parametreler: [
      { anahtar: 'pCap', etiket: 'Ana Çap', tip: 'mesafe', varsayilan: 60, birim: 'mm', min: 0.1, adim: 1 },
      { anahtar: 'pTbCap', etiket: 'Boru Çapı', tip: 'mesafe', varsayilan: 16, birim: 'mm', min: 0.1, adim: 1 },
    ],
  },
  {
    id: 'wedge', etiket: 'Kama (Wedge)', ikon: 'play', workbench: 'part',
    parametreler: [
      { anahtar: 'pEn', etiket: 'En', tip: 'mesafe', varsayilan: 40, birim: 'mm', min: 0.1, adim: 1 },
      { anahtar: 'pBoy', etiket: 'Boy', tip: 'mesafe', varsayilan: 40, birim: 'mm', min: 0.1, adim: 1 },
      { anahtar: 'pYuk', etiket: 'Yükseklik', tip: 'mesafe', varsayilan: 30, birim: 'mm', min: 0.1, adim: 1 },
      { anahtar: 'wedgeLtx', etiket: 'Üst Daralma', tip: 'mesafe', varsayilan: 15, birim: 'mm', min: 0, adim: 1 },
    ],
  },
  {
    id: 'pad', etiket: 'Kabartma (Pad)', ikon: 'level up alternate', workbench: 'part', gerektirir: 'sketch',
    parametreler: [
      { anahtar: 'param', etiket: 'Yükseklik', tip: 'mesafe', varsayilan: 20, birim: 'mm', min: 0.1, max: 2000, adim: 1 },
    ],
  },
  {
    id: 'pocket', etiket: 'Cep (Pocket)', ikon: 'level down alternate', workbench: 'part', gerektirir: 'sketch',
    parametreler: [
      { anahtar: 'param', etiket: 'Derinlik', tip: 'mesafe', varsayilan: 20, birim: 'mm', min: 0.1, max: 2000, adim: 1 },
    ],
  },
  {
    id: 'shaft', etiket: 'Döndür (Shaft)', ikon: 'sync alternate', workbench: 'part', gerektirir: 'sketch',
    parametreler: [],   // tam 360° döndürme — önizleme + onay
  },
  {
    id: 'groove', etiket: 'Oluk (Groove)', ikon: 'undo alternate', workbench: 'part', gerektirir: 'govde',
    parametreler: [],
  },
  {
    id: 'loft', etiket: 'Loft (Kesit Geçiş)', ikon: 'layer group', workbench: 'part', gerektirir: 'sketch',
    parametreler: [],   // OCCT — 3D'de 2+ kesit profili seç (sıralı)
  },
  {
    id: 'sweep', etiket: 'Sweep (Süpürme)', ikon: 'route', workbench: 'part', gerektirir: 'sketch',
    parametreler: [],   // OCCT — profil + yol seç
  },
  {
    id: 'removedLoft', etiket: 'Loft Çıkar (Removed)', ikon: 'layer group', workbench: 'part', gerektirir: 'govde',
    parametreler: [],   // OCCT — 2+ kesit seç, gövdeden çıkar (loft cut)
  },
  {
    id: 'patternDik', etiket: 'Doğrusal Dizi', ikon: 'ellipsis horizontal', workbench: 'part', gerektirir: 'govde',
    parametreler: [
      { anahtar: 'adet', etiket: 'Adet', tip: 'tamsayi', varsayilan: 4, min: 1, max: 200, adim: 1 },
      { anahtar: 'aralik', etiket: 'Aralık', tip: 'mesafe', varsayilan: 40, birim: 'mm', min: 0.1, adim: 1 },
    ],
  },
  {
    id: 'patternDairesel', etiket: 'Dairesel Dizi', ikon: 'asterisk', workbench: 'part', gerektirir: 'govde',
    parametreler: [
      { anahtar: 'adet', etiket: 'Adet', tip: 'tamsayi', varsayilan: 6, min: 1, max: 200, adim: 1 },
      { anahtar: 'aci', etiket: 'Toplam Açı', tip: 'aci', varsayilan: 360, birim: '°', min: 1, max: 360, adim: 5 },
    ],
  },
  {
    id: 'patternIzgara', etiket: 'Izgara Dizi', ikon: 'th', workbench: 'part', gerektirir: 'govde',
    parametreler: [
      { anahtar: 'adet', etiket: 'Sütun', tip: 'tamsayi', varsayilan: 3, min: 1, max: 100, adim: 1 },
      { anahtar: 'adet2', etiket: 'Satır', tip: 'tamsayi', varsayilan: 3, min: 1, max: 100, adim: 1 },
      { anahtar: 'aralik', etiket: 'Yatay Aralık', tip: 'mesafe', varsayilan: 40, birim: 'mm', min: 0.1, adim: 1 },
      { anahtar: 'aralik2', etiket: 'Dikey Aralık', tip: 'mesafe', varsayilan: 40, birim: 'mm', min: 0.1, adim: 1 },
    ],
  },
  {
    id: 'userPattern', etiket: 'Nokta Dizi (User Pattern)', ikon: 'braille', workbench: 'part', gerektirir: 'govde',
    parametreler: [],   // gövdeyi tüm 3D noktalarda çoğaltır (önce Surface → Nokta ile noktalar oluştur)
  },
  {
    id: 'mirror', etiket: 'Aynala (Mirror)', ikon: 'exchange', workbench: 'part', gerektirir: 'govde',
    parametreler: [
      { anahtar: 'aynaTip', etiket: 'Düzlem', tip: 'duzlemRef', varsayilan: 'yz' },
    ],
  },
  // ── CATIA Dönüşümler & gövde değiştiriciler (handler: FikoModellemeYonetici.taslakFeatKur) ──
  {
    id: 'symmetry', etiket: 'Simetri (Symmetry)', ikon: 'clone outline', workbench: 'part', gerektirir: 'govde',
    parametreler: [
      { anahtar: 'aynaTip', etiket: 'Düzlem', tip: 'duzlemRef', varsayilan: 'yz' },
      { anahtar: 'symRef', etiket: 'Nokta/Çizgi Ref.', tip: 'ref', varsayilan: -1, refTipler: ['nokta3d', 'cizgi3d'] },
    ],
  },
  {
    id: 'split', etiket: 'Böl (Split)', ikon: 'cut', workbench: 'part', gerektirir: 'govde',
    parametreler: [
      { anahtar: 'aynaTip', etiket: 'Kesme Düzlemi', tip: 'duzlemRef', varsayilan: 'xy' },
      { anahtar: 'splitOfset', etiket: 'Ofset', tip: 'mesafe', varsayilan: 0, birim: 'mm', min: -2000, max: 2000, adim: 1 },
      { anahtar: 'tersYon', etiket: 'Tutulan Taraf', tip: 'secim', varsayilan: false, secenekler: [
        { deger: false, etiket: 'Pozitif' }, { deger: true, etiket: 'Negatif' },
      ] },
    ],
  },
  {
    id: 'translate', etiket: 'Taşı (Translate)', ikon: 'arrows alternate', workbench: 'part', gerektirir: 'govde',
    parametreler: [
      { anahtar: 'trMod', etiket: 'Vektör Tanımı', tip: 'secim', varsayilan: 'yon', secenekler: [
        { deger: 'yon', etiket: 'Yön + Mesafe' }, { deger: 'koordinat', etiket: 'Koordinat (XYZ)' },
      ] },
      { anahtar: 'trYon', etiket: 'Yön', tip: 'eksenRef', varsayilan: 'x', gorunur: d => d['trMod'] !== 'koordinat' },
      { anahtar: 'trMesafe', etiket: 'Mesafe', tip: 'mesafe', varsayilan: 100, birim: 'mm', min: -5000, max: 5000, adim: 1, gorunur: d => d['trMod'] !== 'koordinat' },
      { anahtar: 'trX', etiket: 'X', tip: 'mesafe', varsayilan: 50, birim: 'mm', min: -5000, max: 5000, adim: 1, gorunur: d => d['trMod'] === 'koordinat' },
      { anahtar: 'trY', etiket: 'Y', tip: 'mesafe', varsayilan: 0, birim: 'mm', min: -5000, max: 5000, adim: 1, gorunur: d => d['trMod'] === 'koordinat' },
      { anahtar: 'trZ', etiket: 'Z', tip: 'mesafe', varsayilan: 0, birim: 'mm', min: -5000, max: 5000, adim: 1, gorunur: d => d['trMod'] === 'koordinat' },
    ],
  },
  {
    id: 'rotate', etiket: 'Döndür (Rotate)', ikon: 'redo', workbench: 'part', gerektirir: 'govde',
    parametreler: [
      { anahtar: 'aci', etiket: 'Açı', tip: 'aci', varsayilan: 90, birim: '°', min: -360, max: 360, adim: 5 },
      { anahtar: 'eksenTip', etiket: 'Eksen', tip: 'eksenRef', varsayilan: 'z' },
    ],
  },
  {
    id: 'scaling', etiket: 'Ölçekle (Scaling)', ikon: 'expand arrows alternate', workbench: 'part', gerektirir: 'govde',
    parametreler: [
      { anahtar: 'scaleFaktor', etiket: 'Katsayı', tip: 'sayi', varsayilan: 1.5, birim: '×', min: 0.01, max: 100, adim: 0.1 },
    ],
  },
  {
    id: 'affinity', etiket: 'Afinite (Affinity)', ikon: 'arrows alternate horizontal', workbench: 'part', gerektirir: 'govde',
    parametreler: [
      { anahtar: 'affX', etiket: 'X Oran', tip: 'sayi', varsayilan: 1.5, birim: '×', min: 0.01, max: 100, adim: 0.1 },
      { anahtar: 'affY', etiket: 'Y Oran', tip: 'sayi', varsayilan: 1, birim: '×', min: 0.01, max: 100, adim: 0.1 },
      { anahtar: 'affZ', etiket: 'Z Oran', tip: 'sayi', varsayilan: 1, birim: '×', min: 0.01, max: 100, adim: 0.1 },
    ],
  },
  {
    id: 'axisToAxis', etiket: 'Eksen→Eksen (Axis to Axis)', ikon: 'crosshairs', workbench: 'part', gerektirir: 'govde',
    parametreler: [
      { anahtar: 'ref1', etiket: 'Hedef Nokta', tip: 'ref', varsayilan: -1, refTipler: ['nokta3d'] },
      { anahtar: 'eksenRef', etiket: 'Hedef Eksen', tip: 'eksenRef', varsayilan: 'z' },
    ],
  },
  {
    id: 'thickness', etiket: 'Kalınlık (Thickness)', ikon: 'clone', workbench: 'part', gerektirir: 'govde',
    parametreler: [
      { anahtar: 'kalinlik', etiket: 'Kalınlık (±)', tip: 'mesafe', varsayilan: 2, birim: 'mm', min: -500, max: 500, adim: 0.5 },
      { anahtar: 'tersYon', etiket: 'Yön', tip: 'secim', varsayilan: false, secenekler: [
        { deger: false, etiket: 'Ekle (dışa)' }, { deger: true, etiket: 'Çıkar (içe)' },
      ] },
    ],
  },
  {
    id: 'slot', etiket: 'Slot (Kanal)', ikon: 'minus', workbench: 'part', gerektirir: 'sketch',
    parametreler: [],   // OCCT — 3D'de profil + yol seç (sweep çıkar)
  },
  {
    id: 'combine', etiket: 'Solid Combine', ikon: 'object group', workbench: 'part', gerektirir: 'sketch',
    parametreler: [],   // OCCT — 3D'de 2 profil seç (kesişim hacmi)
  },
  // ── GSD Yüzey (Surface) komutları (handler: taslakFeatKur 'yuzeyXxx') ──
  {
    id: 'yuzeyExtrude', etiket: 'Yüzey Uzat', ikon: 'clone outline', workbench: 'surface', gerektirir: 'sketch',
    parametreler: [
      { anahtar: 'param', etiket: 'Uzatma', tip: 'mesafe', varsayilan: 40, birim: 'mm', min: 0.1, max: 5000, adim: 1 },
    ],
  },
  {
    id: 'yuzeyRevolve', etiket: 'Yüzey Döndür', ikon: 'sync', workbench: 'surface', gerektirir: 'sketch',
    parametreler: [
      { anahtar: 'aci', etiket: 'Açı', tip: 'aci', varsayilan: 360, birim: '°', min: 1, max: 360, adim: 5 },
    ],
  },
  {
    id: 'yuzeyFill', etiket: 'Dolgu Yüzey', ikon: 'square outline', workbench: 'surface', gerektirir: 'sketch',
    parametreler: [],
  },
  {
    id: 'yuzeyLoft', etiket: 'Çok-Kesit Yüzey', ikon: 'layer group', workbench: 'surface', gerektirir: 'sketch',
    parametreler: [],   // 3D'de 2+ kesit profili seç
  },
  {
    id: 'yuzeySweep', etiket: 'Süpürme Yüzey', ikon: 'route', workbench: 'surface', gerektirir: 'sketch',
    parametreler: [],   // 3D'de profil + yol seç
  },
  {
    id: 'yuzeySphere', etiket: 'Küre Yüzey (Sphere)', ikon: 'globe', workbench: 'surface',
    parametreler: [
      { anahtar: 'pCap', etiket: 'Çap', tip: 'mesafe', varsayilan: 50, birim: 'mm', min: 0.1, adim: 1 },
    ],
  },
  {
    id: 'yuzeyCylinder', etiket: 'Silindir Yüzey (Cylinder)', ikon: 'circle outline', workbench: 'surface',
    parametreler: [
      { anahtar: 'pCap', etiket: 'Çap', tip: 'mesafe', varsayilan: 50, birim: 'mm', min: 0.1, adim: 1 },
      { anahtar: 'pYuk', etiket: 'Yükseklik', tip: 'mesafe', varsayilan: 60, birim: 'mm', min: 0.1, adim: 1 },
      { anahtar: 'aynaTip', etiket: 'Eksen Düzlemi', tip: 'duzlemRef', varsayilan: 'xy' },
    ],
  },
  // ── GSD Yüzey Analizi (vertex-renkli overlay) ──
  {
    id: 'analiz_draft', etiket: 'Draft Analizi', ikon: 'tint', workbench: 'analiz', gerektirir: 'govde',
    parametreler: [
      { anahtar: 'eksen', etiket: 'Çekme Yönü', tip: 'secim', varsayilan: 'z', secenekler: [ { deger: 'x', etiket: 'X' }, { deger: 'y', etiket: 'Y' }, { deger: 'z', etiket: 'Z' } ] },
      { anahtar: 'minAci', etiket: 'Min. Eğim', tip: 'aci', varsayilan: 3, birim: '°', min: 0, max: 45, adim: 0.5 },
    ],
  },
  {
    id: 'analiz_egrilik', etiket: 'Eğrilik Analizi (Curvature)', ikon: 'chart line', workbench: 'analiz', gerektirir: 'govde',
    parametreler: [],
  },
  {
    id: 'analiz_connect', etiket: 'Connect Checker (Yüzey Boşluk)', ikon: 'linkify', workbench: 'analiz',
    parametreler: [],
  },
  {
    id: 'analiz_egriBaglanti', etiket: 'Eğri Bağlantı (G0/G1)', ikon: 'share', workbench: 'analiz',
    parametreler: [],
  },
  {
    id: 'analiz_porcupine', etiket: 'Porcupine (Eğrilik Tarağı)', ikon: 'pagelines', workbench: 'analiz',
    parametreler: [
      { anahtar: 'olcek', etiket: 'Diken Ölçeği', tip: 'sayi', varsayilan: 30, min: 1, max: 200, adim: 5 },
    ],
  },
  {
    id: 'analiz_reflect', etiket: 'Reflect Line (Silüet)', ikon: 'film', workbench: 'analiz', gerektirir: 'govde',
    parametreler: [
      { anahtar: 'eksen', etiket: 'Yön', tip: 'secim', varsayilan: 'z', secenekler: [ { deger: 'x', etiket: 'X' }, { deger: 'y', etiket: 'Y' }, { deger: 'z', etiket: 'Z' } ] },
    ],
  },
  {
    id: 'analiz_kutle', etiket: 'Kütle Özellikleri (Hacim/COG)', ikon: 'balance scale', workbench: 'analiz', gerektirir: 'govde',
    parametreler: [],
  },
  {
    id: 'analiz_mesafe', etiket: 'Hassas Mesafe (Min)', ikon: 'arrows alternate horizontal', workbench: 'analiz',
    parametreler: [],
  },
  {
    id: 'analiz_kontrol', etiket: 'Geometri Kontrol (Valid)', ikon: 'check circle', workbench: 'analiz', gerektirir: 'govde',
    parametreler: [],
  },
  {
    id: 'analiz_bbox', etiket: 'Sınır Kutusu (Bounding Box)', ikon: 'cube', workbench: 'analiz', gerektirir: 'govde',
    parametreler: [],
  },
  {
    id: 'analiz_kapat', etiket: 'Analizi Kapat', ikon: 'eye slash', workbench: 'analiz', gerektirir: 'govde',
    parametreler: [],
  },
  // ── 3D CAM operasyonları (parametre dialogu + canlı toolpath önizleme) ──
  {
    id: 'cam3d_parallel', etiket: 'Parallel Finiş', ikon: 'align justify', workbench: 'cam', gerektirir: 'govde',
    parametreler: [
      { anahtar: 'takimTip', etiket: 'Takım', tip: 'secim', varsayilan: 'kure', secenekler: [ { deger: 'kure', etiket: 'Küresel (Ball)' }, { deger: 'bullnose', etiket: 'Toroidal (Bull)' } ] },
      { anahtar: 'takimCap', etiket: 'Takım Çapı', tip: 'mesafe', varsayilan: 6, birim: 'mm', min: 0.5, max: 50, adim: 0.5 },
      { anahtar: 'scallop', etiket: 'Scallop (kalıntı)', tip: 'mesafe', varsayilan: 0.08, birim: 'mm', min: 0.005, max: 2, adim: 0.01 },
      { anahtar: 'stockLeave', etiket: 'Finiş Payı', tip: 'mesafe', varsayilan: 0, birim: 'mm', min: 0, max: 5, adim: 0.1 },
      { anahtar: 'eksen', etiket: 'Tarama Yönü', tip: 'secim', varsayilan: 'x', secenekler: [ { deger: 'x', etiket: 'X' }, { deger: 'y', etiket: 'Y' } ] },
      { anahtar: 'girisTip', etiket: 'Giriş (Lead-in)', tip: 'secim', varsayilan: 'dik', secenekler: [ { deger: 'dik', etiket: 'Dik Plonj' }, { deger: 'rampa', etiket: 'Rampa' }, { deger: 'yay', etiket: 'Teğet Yay' } ] },
      { anahtar: 'cikisTip', etiket: 'Çıkış (Lead-out)', tip: 'secim', varsayilan: 'dik', secenekler: [ { deger: 'dik', etiket: 'Dik' }, { deger: 'rampa', etiket: 'Rampa' }, { deger: 'yay', etiket: 'Teğet Yay' } ] },
      { anahtar: 'yaklasmaZ', etiket: 'Yaklaşma Payı', tip: 'mesafe', varsayilan: 2, birim: 'mm', min: 0.2, max: 30, adim: 0.5 },
      { anahtar: 'girisBoy', etiket: 'Giriş Yarıçap/Boy', tip: 'mesafe', varsayilan: 0, birim: 'mm', min: 0, max: 50, adim: 0.5 },
    ],
  },
  {
    id: 'cam3d_roughing', etiket: 'Z-Level Kaba', ikon: 'layer group', workbench: 'cam', gerektirir: 'govde',
    parametreler: [
      { anahtar: 'takimCap', etiket: 'Takım Çapı (düz)', tip: 'mesafe', varsayilan: 10, birim: 'mm', min: 1, max: 80, adim: 1 },
      { anahtar: 'stepdown', etiket: 'Kademe (stepdown)', tip: 'mesafe', varsayilan: 5, birim: 'mm', min: 0.5, max: 50, adim: 0.5 },
      { anahtar: 'stockLeave', etiket: 'Finiş Payı', tip: 'mesafe', varsayilan: 0.3, birim: 'mm', min: 0, max: 5, adim: 0.1 },
    ],
  },
  {
    id: 'cam3d_waterline', etiket: 'Waterline Finiş', ikon: 'water', workbench: 'cam', gerektirir: 'govde',
    parametreler: [
      { anahtar: 'takimCap', etiket: 'Takım Çapı (ball)', tip: 'mesafe', varsayilan: 6, birim: 'mm', min: 0.5, max: 50, adim: 0.5 },
      { anahtar: 'stepdown', etiket: 'Z Kademe', tip: 'mesafe', varsayilan: 2, birim: 'mm', min: 0.2, max: 20, adim: 0.2 },
    ],
  },
  {
    id: 'cam3d_pencil', etiket: 'Pencil (İç Köşe)', ikon: 'pencil', workbench: 'cam', gerektirir: 'govde',
    parametreler: [
      { anahtar: 'takimCap', etiket: 'Takım Çapı (ball)', tip: 'mesafe', varsayilan: 3, birim: 'mm', min: 0.3, max: 20, adim: 0.5 },
    ],
  },
  {
    id: 'sketch', etiket: 'Eskiz (Sketch)', ikon: 'pencil alternate', workbench: 'part',
    parametreler: [
      { anahtar: 'duzlemTip', etiket: 'Düzlem / Yüz', tip: 'secim', varsayilan: 'xy', secenekler: [
        { deger: 'xy', etiket: 'XY Düzlemi' }, { deger: 'xz', etiket: 'XZ Düzlemi' }, { deger: 'yz', etiket: 'YZ Düzlemi' },
        { deger: 'yuz', etiket: 'Bir Yüz Seç' },
      ] },
    ],
  },
  {
    id: 'malzeme', etiket: 'Malzeme Ata', ikon: 'tint', workbench: 'part', gerektirir: 'govde',
    parametreler: [
      { anahtar: 'malzeme', etiket: 'Malzeme', tip: 'secim', varsayilan: 'Çelik', secenekler: [
        { deger: 'Çelik', etiket: 'Çelik (7.85)' }, { deger: 'Paslanmaz Çelik', etiket: 'Paslanmaz (8.0)' },
        { deger: 'Alüminyum', etiket: 'Alüminyum (2.7)' }, { deger: 'Pirinç', etiket: 'Pirinç (8.5)' },
        { deger: 'Bakır', etiket: 'Bakır (8.96)' }, { deger: 'Titanyum', etiket: 'Titanyum (4.51)' },
        { deger: 'Döküm Demir', etiket: 'Döküm Demir (7.2)' }, { deger: 'Plastik (ABS)', etiket: 'Plastik ABS (1.05)' },
        { deger: 'Ahşap (Meşe)', etiket: 'Ahşap Meşe (0.75)' }, { deger: 'Cam', etiket: 'Cam (2.5)' },
        { deger: 'Beton', etiket: 'Beton (2.4)' }, { deger: 'Altın', etiket: 'Altın (19.32)' },
      ] },
    ],
  },
  {
    id: 'refDuzlem', etiket: 'Referans Düzlem', ikon: 'clone outline', workbench: 'part',
    parametreler: [
      { anahtar: 'taban', etiket: 'Temel', tip: 'secim', varsayilan: 'xy', secenekler: [
        { deger: 'xy', etiket: 'XY' }, { deger: 'xz', etiket: 'XZ' }, { deger: 'yz', etiket: 'YZ' },
      ] },
      { anahtar: 'ofset', etiket: 'Ofset Mesafe', tip: 'mesafe', varsayilan: 50, birim: 'mm', min: -2000, max: 2000, adim: 5 },
    ],
  },
  {
    id: 'fillet3d', etiket: 'Kenar Yuvarlat (Fillet)', ikon: 'circle notch', workbench: 'part', gerektirir: 'govde',
    parametreler: [
      { anahtar: 'kenarMesafe', etiket: 'Yarıçap', tip: 'mesafe', varsayilan: 4, birim: 'mm', min: 0.1, max: 500, adim: 0.5 },
      { anahtar: 'kenarAci', etiket: 'Kenar Eşiği', tip: 'aci', varsayilan: 30, birim: '°', min: 5, max: 89, adim: 5 },
    ],
  },
  {
    id: 'chamfer3d', etiket: 'Kenar Pah (Chamfer)', ikon: 'cut', workbench: 'part', gerektirir: 'govde',
    parametreler: [
      { anahtar: 'chamferMod', etiket: 'Mod', tip: 'secim', varsayilan: 'simetrik', secenekler: [
        { deger: 'simetrik', etiket: 'Mesafe (simetrik)' }, { deger: 'length2', etiket: 'Mesafe / Mesafe' }, { deger: 'aci', etiket: 'Mesafe / Açı' },
      ] },
      { anahtar: 'kenarMesafe', etiket: 'Mesafe 1', tip: 'mesafe', varsayilan: 4, birim: 'mm', min: 0.1, max: 500, adim: 0.5 },
      { anahtar: 'kenarMesafe2', etiket: 'Mesafe 2', tip: 'mesafe', varsayilan: 4, birim: 'mm', min: 0.1, max: 500, adim: 0.5, gorunur: d => d['chamferMod'] === 'length2' },
      { anahtar: 'chamferAci', etiket: 'Açı', tip: 'aci', varsayilan: 45, birim: '°', min: 1, max: 89, adim: 1, gorunur: d => d['chamferMod'] === 'aci' },
      { anahtar: 'kenarAci', etiket: 'Kenar Eşiği', tip: 'aci', varsayilan: 30, birim: '°', min: 5, max: 89, adim: 5 },
    ],
  },
  {
    id: 'rib', etiket: 'Kaburga (Rib)', ikon: 'grip lines vertical', workbench: 'part', gerektirir: 'sketch',
    parametreler: [
      { anahtar: 'kalinlik', etiket: 'Kalınlık', tip: 'mesafe', varsayilan: 6, birim: 'mm', min: 0.2, max: 500, adim: 0.5 },
      { anahtar: 'param', etiket: 'Uzunluk', tip: 'mesafe', varsayilan: 30, birim: 'mm', min: 0.2, max: 2000, adim: 1 },
      { anahtar: 'yon', etiket: 'Yön', tip: 'secim', varsayilan: 'arti', secenekler: [
        { deger: 'arti', etiket: '+ Normal' }, { deger: 'eksi', etiket: '− Normal' }, { deger: 'cift', etiket: 'Çift Yön' },
      ] },
    ],
  },
  {
    id: 'stiffener', etiket: 'Feder (Stiffener)', ikon: 'caret square up', workbench: 'part', gerektirir: 'govde',
    parametreler: [
      { anahtar: 'kalinlik', etiket: 'Kalınlık', tip: 'mesafe', varsayilan: 6, birim: 'mm', min: 0.2, max: 500, adim: 0.5 },
    ],
  },
  {
    id: 'removeLump', etiket: 'Parça Sil (Remove Lump)', ikon: 'eraser', workbench: 'part', gerektirir: 'govde',
    parametreler: [],   // kopuk solid parçalardan en büyüğünü tutar
  },
  {
    id: 'removeFace', etiket: 'Yüz Sil (Remove Face)', ikon: 'clone outline', workbench: 'part', gerektirir: 'govde',
    parametreler: [],   // 3D'de yüz(ler) seç → defeaturing ile kaldır
  },
  {
    id: 'faceFillet', etiket: 'Yüz Fillet (Face-Face)', ikon: 'circle notch', workbench: 'part', gerektirir: 'govde',
    parametreler: [
      { anahtar: 'kenarMesafe', etiket: 'Yarıçap', tip: 'mesafe', varsayilan: 4, birim: 'mm', min: 0.1, max: 500, adim: 0.5 },
    ],   // 3D'de komşu 2 yüz seç → paylaşılan kenara fillet
  },
  {
    id: 'triFillet', etiket: 'Tritangent Fillet', ikon: 'circle notch', workbench: 'part', gerektirir: 'govde',
    parametreler: [
      { anahtar: 'kenarMesafe', etiket: 'Yarıçap (0=oto)', tip: 'mesafe', varsayilan: 0, birim: 'mm', min: 0, max: 500, adim: 0.5 },
    ],   // 3D'de şerit/orta yüz seç → oto-yarıçapla tangent yuvarla
  },
  {
    id: 'replaceFace', etiket: 'Yüz Değiştir (Replace)', ikon: 'exchange', workbench: 'part', gerektirir: 'govde',
    parametreler: [
      { anahtar: 'aynaTip', etiket: 'Hedef Düzlem', tip: 'duzlemRef', varsayilan: 'xy' },
      { anahtar: 'splitOfset', etiket: 'Ofset', tip: 'mesafe', varsayilan: 0, birim: 'mm', min: -2000, max: 2000, adim: 1 },
    ],   // 3D'de yüz seç → hedef düzleme taşı (yüzeyi düzlemle değiştir)
  },
  {
    id: 'closeSurface', etiket: 'Yüzey Kapat (Close)', ikon: 'object group', workbench: 'surface', gerektirir: 'sketch',
    parametreler: [],   // tüm yüzeyleri dikip katı yapar
  },
  {
    id: 'healing', etiket: 'Onar (Healing)', ikon: 'medkit', workbench: 'surface', gerektirir: 'govde',
    parametreler: [
      { anahtar: 'param', etiket: 'Tolerans', tip: 'mesafe', varsayilan: 0.01, birim: 'mm', min: 0.001, max: 10, adim: 0.01 },
    ],
  },
  {
    id: 'simplify', etiket: 'Sadeleştir (Simplify)', ikon: 'compress', workbench: 'surface', gerektirir: 'govde',
    parametreler: [],
  },
  {
    id: 'offsetShape', etiket: 'Katı Offset (Büyüt/Küçült)', ikon: 'expand arrows alternate', workbench: 'part', gerektirir: 'govde',
    parametreler: [
      { anahtar: 'param', etiket: 'Offset (±)', tip: 'mesafe', varsayilan: 5, birim: 'mm', min: -200, max: 200, adim: 0.5 },
    ],
  },
  {
    id: 'untrim', etiket: 'Untrim (Sınır Kaldır)', ikon: 'expand', workbench: 'surface', gerektirir: 'govde',
    parametreler: [
      { anahtar: 'yuzIndex', etiket: 'Yüz No', tip: 'tamsayi', varsayilan: 0, min: 0, max: 200, adim: 1 },
    ],
  },
  {
    id: 'multiExtract', etiket: 'Çoklu Çıkar (Multi Extract)', ikon: 'clone outline', workbench: 'surface', gerektirir: 'govde',
    parametreler: [],
  },
  {
    id: 'disassemble', etiket: 'Parçala (Disassemble)', ikon: 'puzzle piece', workbench: 'surface', gerektirir: 'govde',
    parametreler: [],
  },
  {
    id: 'shell', etiket: 'Kabuk (Shell)', ikon: 'box open', workbench: 'part', gerektirir: 'govde',
    parametreler: [
      { anahtar: 'kalinlik', etiket: 'Et Kalınlığı', tip: 'mesafe', varsayilan: 4, birim: 'mm', min: 0.2, max: 200, adim: 0.5 },
    ],
  },
  {
    id: 'draft', etiket: 'Eğim (Draft)', ikon: 'sort amount down', workbench: 'part', gerektirir: 'govde',
    parametreler: [
      { anahtar: 'aci', etiket: 'Eğim Açısı', tip: 'aci', varsayilan: 5, birim: '°', min: -45, max: 45, adim: 0.5 },
      { anahtar: 'taban', etiket: 'Nötr Düzlem', tip: 'secim', varsayilan: 'alt', secenekler: [
        { deger: 'alt', etiket: 'Alt (Z min)' }, { deger: 'ust', etiket: 'Üst (Z max)' }, { deger: 'orta', etiket: 'Orta' },
      ] },
      { anahtar: 'eksenTip', etiket: 'Çekme Ekseni', tip: 'eksenRef', varsayilan: 'z' },
    ],
  },

  // ============ TESİSAT WORKBENCH (makro) ============
  {
    id: 'boru', etiket: 'Boru (Pipe)', ikon: 'grip lines', workbench: 'tesisat',
    parametreler: [
      { anahtar: 'mCap', etiket: 'Dış Çap', tip: 'mesafe', varsayilan: 30, birim: 'mm', min: 4, max: 1000, adim: 1 },
      { anahtar: 'mEtKal', etiket: 'Et Kalınlığı', tip: 'mesafe', varsayilan: 3, birim: 'mm', min: 0.5, max: 100, adim: 0.5 },
      { anahtar: 'mUzun', etiket: 'Uzunluk', tip: 'mesafe', varsayilan: 120, birim: 'mm', min: 2, max: 5000, adim: 5 },
      { anahtar: 'ekleme', etiket: 'Birleştir / Çıkar', tip: 'boolean', varsayilan: true },
    ],
  },
  {
    id: 'dirsek', etiket: 'Dirsek / Te (Fitting)', ikon: 'random', workbench: 'tesisat',
    parametreler: [
      { anahtar: 'mCap', etiket: 'Çap', tip: 'mesafe', varsayilan: 30, birim: 'mm', min: 4, max: 1000, adim: 1 },
      { anahtar: 'mEtKal', etiket: 'Et Kalınlığı', tip: 'mesafe', varsayilan: 3, birim: 'mm', min: 0.5, max: 100, adim: 0.5 },
      { anahtar: 'mUzun', etiket: 'Kol Boyu', tip: 'mesafe', varsayilan: 60, birim: 'mm', min: 4, max: 2000, adim: 2 },
      { anahtar: 'mAci', etiket: 'Açı', tip: 'aci', varsayilan: 90, birim: '°', min: 15, max: 165, adim: 5 },
      { anahtar: 'ekleme', etiket: 'Birleştir / Çıkar', tip: 'boolean', varsayilan: true },
    ],
  },

  // ============ TAKI WORKBENCH (makro) ============
  {
    id: 'yuzuk', etiket: 'Yüzük (Ring)', ikon: 'circle outline', workbench: 'taki',
    parametreler: [
      { anahtar: 'mCap', etiket: 'İç Çap (parmak)', tip: 'mesafe', varsayilan: 18, birim: 'mm', min: 8, max: 40, adim: 0.5 },
      { anahtar: 'mBand', etiket: 'Band Kalınlığı', tip: 'mesafe', varsayilan: 4, birim: 'mm', min: 0.5, max: 20, adim: 0.5 },
      { anahtar: 'mUzun', etiket: 'Band Genişliği', tip: 'mesafe', varsayilan: 5, birim: 'mm', min: 1, max: 30, adim: 0.5 },
      { anahtar: 'ekleme', etiket: 'Birleştir / Çıkar', tip: 'boolean', varsayilan: true },
    ],
  },
  {
    id: 'tasYuvasi', etiket: 'Taş Yuvası (Prong)', ikon: 'gem', workbench: 'taki',
    parametreler: [
      { anahtar: 'mTasCap', etiket: 'Taş Çapı', tip: 'mesafe', varsayilan: 8, birim: 'mm', min: 1, max: 60, adim: 0.5 },
      { anahtar: 'mProngAdet', etiket: 'Tırnak Adedi', tip: 'tamsayi', varsayilan: 4, min: 3, max: 12, adim: 1 },
      { anahtar: 'mProngCap', etiket: 'Tırnak Çapı', tip: 'mesafe', varsayilan: 1.2, birim: 'mm', min: 0.4, max: 8, adim: 0.2 },
      { anahtar: 'mProngYuk', etiket: 'Tırnak Boyu', tip: 'mesafe', varsayilan: 6, birim: 'mm', min: 1, max: 40, adim: 0.5 },
      { anahtar: 'ekleme', etiket: 'Birleştir / Çıkar', tip: 'boolean', varsayilan: true },
    ],
  },
  {
    id: 'bezel', etiket: 'Bezel (Çerçeve Yuva)', ikon: 'certificate', workbench: 'taki',
    parametreler: [
      { anahtar: 'mTasCap', etiket: 'Taş Çapı', tip: 'mesafe', varsayilan: 8, birim: 'mm', min: 1, max: 60, adim: 0.5 },
      { anahtar: 'mEtKal', etiket: 'Çeper Kalınlığı', tip: 'mesafe', varsayilan: 1, birim: 'mm', min: 0.3, max: 10, adim: 0.2 },
      { anahtar: 'mProngYuk', etiket: 'Yükseklik', tip: 'mesafe', varsayilan: 6, birim: 'mm', min: 1, max: 40, adim: 0.5 },
      { anahtar: 'ekleme', etiket: 'Birleştir / Çıkar', tip: 'boolean', varsayilan: true },
    ],
  },

  // ====================== MİMARLIK WORKBENCH (İnşaat çoklu-feature makroları) ======================
  {
    id: 'duvar', etiket: 'Duvar', ikon: 'th large', workbench: 'insaat',
    parametreler: [
      { anahtar: 'uzunluk', etiket: 'Uzunluk', tip: 'mesafe', varsayilan: 300, birim: 'cm', min: 10, adim: 5 },
      { anahtar: 'kalinlik', etiket: 'Kalınlık', tip: 'mesafe', varsayilan: 20, birim: 'cm', min: 2, adim: 1 },
      { anahtar: 'yukseklik', etiket: 'Yükseklik', tip: 'mesafe', varsayilan: 280, birim: 'cm', min: 10, adim: 5 },
      { anahtar: 'kat', etiket: 'Kat Kotu (Z)', tip: 'mesafe', varsayilan: 0, birim: 'cm', adim: 10 },
      { anahtar: 'kapiGenislik', etiket: 'Kapı Genişliği', tip: 'mesafe', varsayilan: 90, birim: 'cm', min: 0, adim: 5 },
      { anahtar: 'kapiYukseklik', etiket: 'Kapı Yüksekliği', tip: 'mesafe', varsayilan: 210, birim: 'cm', min: 0, adim: 5 },
      { anahtar: 'kapiKonum', etiket: 'Kapı Konumu (X)', tip: 'mesafe', varsayilan: -75, birim: 'cm', adim: 5 },
      { anahtar: 'pencereGenislik', etiket: 'Pencere Genişliği', tip: 'mesafe', varsayilan: 120, birim: 'cm', min: 0, adim: 5 },
      { anahtar: 'pencereYukseklik', etiket: 'Pencere Yüksekliği', tip: 'mesafe', varsayilan: 120, birim: 'cm', min: 0, adim: 5 },
      { anahtar: 'pencereKonum', etiket: 'Pencere Konumu (X)', tip: 'mesafe', varsayilan: 75, birim: 'cm', adim: 5 },
      { anahtar: 'pencereDenizlik', etiket: 'Denizlik Yüksekliği', tip: 'mesafe', varsayilan: 90, birim: 'cm', min: 0, adim: 5 },
    ],
  },
  {
    id: 'doseme', etiket: 'Döşeme / Plak', ikon: 'square outline', workbench: 'insaat',
    parametreler: [
      { anahtar: 'en', etiket: 'En', tip: 'mesafe', varsayilan: 400, birim: 'cm', min: 10, adim: 10 },
      { anahtar: 'boy', etiket: 'Boy', tip: 'mesafe', varsayilan: 400, birim: 'cm', min: 10, adim: 10 },
      { anahtar: 'kalinlik', etiket: 'Kalınlık', tip: 'mesafe', varsayilan: 20, birim: 'cm', min: 2, adim: 1 },
      { anahtar: 'kot', etiket: 'Kot (Z)', tip: 'mesafe', varsayilan: 0, birim: 'cm', adim: 10 },
    ],
  },
  {
    id: 'kolon', etiket: 'Kolon', ikon: 'grip lines vertical', workbench: 'insaat',
    parametreler: [
      { anahtar: 'yuvarlak', etiket: 'Yuvarlak Kolon', tip: 'boolean', varsayilan: false },
      { anahtar: 'en', etiket: 'En', tip: 'mesafe', varsayilan: 40, birim: 'cm', min: 5, adim: 1 },
      { anahtar: 'derinlik', etiket: 'Derinlik', tip: 'mesafe', varsayilan: 40, birim: 'cm', min: 5, adim: 1 },
      { anahtar: 'cap', etiket: 'Çap (yuvarlaksa)', tip: 'mesafe', varsayilan: 40, birim: 'cm', min: 5, adim: 1 },
      { anahtar: 'yukseklik', etiket: 'Yükseklik', tip: 'mesafe', varsayilan: 280, birim: 'cm', min: 10, adim: 5 },
      { anahtar: 'kot', etiket: 'Taban Kotu (Z)', tip: 'mesafe', varsayilan: 0, birim: 'cm', adim: 10 },
    ],
  },
  {
    id: 'kiris', etiket: 'Kiriş', ikon: 'minus', workbench: 'insaat',
    parametreler: [
      { anahtar: 'uzunluk', etiket: 'Uzunluk', tip: 'mesafe', varsayilan: 400, birim: 'cm', min: 10, adim: 10 },
      { anahtar: 'genislik', etiket: 'Genişlik', tip: 'mesafe', varsayilan: 20, birim: 'cm', min: 2, adim: 1 },
      { anahtar: 'yukseklik', etiket: 'Yükseklik', tip: 'mesafe', varsayilan: 40, birim: 'cm', min: 2, adim: 1 },
      { anahtar: 'kot', etiket: 'Alt Kot (Z)', tip: 'mesafe', varsayilan: 240, birim: 'cm', adim: 10 },
    ],
  },
  {
    id: 'cati', etiket: 'Çatı (Beşik)', ikon: 'home', workbench: 'insaat',
    parametreler: [
      { anahtar: 'en', etiket: 'Taban Eni', tip: 'mesafe', varsayilan: 400, birim: 'cm', min: 10, adim: 10 },
      { anahtar: 'boy', etiket: 'Derinlik (Sırt)', tip: 'mesafe', varsayilan: 400, birim: 'cm', min: 10, adim: 10 },
      { anahtar: 'yukseklik', etiket: 'Çatı Yüksekliği', tip: 'mesafe', varsayilan: 150, birim: 'cm', min: 5, adim: 5 },
      { anahtar: 'sacak', etiket: 'Saçak Payı', tip: 'mesafe', varsayilan: 30, birim: 'cm', min: 0, adim: 5 },
      { anahtar: 'kot', etiket: 'Taban Kotu (Z)', tip: 'mesafe', varsayilan: 0, birim: 'cm', adim: 10 },
    ],
  },
  {
    id: 'merdiven', etiket: 'Merdiven', ikon: 'sort amount up', workbench: 'insaat',
    parametreler: [
      { anahtar: 'basamak', etiket: 'Basamak Sayısı', tip: 'tamsayi', varsayilan: 12, min: 1, max: 60, adim: 1 },
      { anahtar: 'genislik', etiket: 'Genişlik', tip: 'mesafe', varsayilan: 100, birim: 'cm', min: 30, adim: 5 },
      { anahtar: 'derinlik', etiket: 'Basamak Derinliği', tip: 'mesafe', varsayilan: 28, birim: 'cm', min: 15, adim: 1 },
      { anahtar: 'basamakYuk', etiket: 'Rıht (Basamak Yük.)', tip: 'mesafe', varsayilan: 18, birim: 'cm', min: 10, adim: 1 },
      { anahtar: 'kot', etiket: 'Taban Kotu (Z)', tip: 'mesafe', varsayilan: 0, birim: 'cm', adim: 10 },
    ],
  },
  {
    id: 'bina', etiket: 'Komple Bina', ikon: 'building', workbench: 'insaat',
    parametreler: [
      { anahtar: 'en', etiket: 'En', tip: 'mesafe', varsayilan: 800, birim: 'cm', min: 100, adim: 50 },
      { anahtar: 'boy', etiket: 'Boy', tip: 'mesafe', varsayilan: 1000, birim: 'cm', min: 100, adim: 50 },
      { anahtar: 'katSayisi', etiket: 'Kat Sayısı', tip: 'tamsayi', varsayilan: 3, min: 1, max: 50, adim: 1 },
      { anahtar: 'katYuksekligi', etiket: 'Kat Yüksekliği', tip: 'mesafe', varsayilan: 300, birim: 'cm', min: 200, adim: 10 },
      { anahtar: 'duvarKalinlik', etiket: 'Duvar Kalınlığı', tip: 'mesafe', varsayilan: 20, birim: 'cm', min: 5, adim: 1 },
      { anahtar: 'dosemeKalinlik', etiket: 'Döşeme Kalınlığı', tip: 'mesafe', varsayilan: 20, birim: 'cm', min: 5, adim: 1 },
      { anahtar: 'cati', etiket: 'Çatı Ekle', tip: 'boolean', varsayilan: true },
      { anahtar: 'catiYuksekligi', etiket: 'Çatı Yüksekliği', tip: 'mesafe', varsayilan: 200, birim: 'cm', min: 10, adim: 10 },
    ],
  },

  // ====================== ÇELİK WORKBENCH (Profil + birleşim) ======================
  {
    id: 'celikProfil', etiket: 'Çelik Profil', ikon: 'indent', workbench: 'celik',
    parametreler: [
      { anahtar: 'profilTip', etiket: 'Kesit Tipi', tip: 'secim', varsayilan: 'IPE', secenekler: [
        { deger: 'IPE', etiket: 'IPE' }, { deger: 'HEA', etiket: 'HEA' }, { deger: 'HEB', etiket: 'HEB' }, { deger: 'L', etiket: 'L (Köşebent)' },
      ] },
      { anahtar: 'h', etiket: 'Yükseklik (h)', tip: 'mesafe', varsayilan: 200, birim: 'mm', min: 20, adim: 5 },
      { anahtar: 'b', etiket: 'Başlık Geniş. (b)', tip: 'mesafe', varsayilan: 100, birim: 'mm', min: 10, adim: 5 },
      { anahtar: 'tw', etiket: 'Gövde Et (tw)', tip: 'mesafe', varsayilan: 6, birim: 'mm', min: 1, adim: 0.5 },
      { anahtar: 'tf', etiket: 'Başlık Et (tf)', tip: 'mesafe', varsayilan: 9, birim: 'mm', min: 1, adim: 0.5 },
      { anahtar: 'uzunluk', etiket: 'Profil Boyu', tip: 'mesafe', varsayilan: 1000, birim: 'mm', min: 10, adim: 10 },
      { anahtar: 'kot', etiket: 'Kot (Z)', tip: 'mesafe', varsayilan: 0, birim: 'mm', adim: 10 },
    ],
  },
  {
    id: 'birlesimPlakasi', etiket: 'Birleşim Plakası', ikon: 'th', workbench: 'celik',
    parametreler: [
      { anahtar: 'en', etiket: 'En', tip: 'mesafe', varsayilan: 200, birim: 'mm', min: 20, adim: 5 },
      { anahtar: 'boy', etiket: 'Boy', tip: 'mesafe', varsayilan: 200, birim: 'mm', min: 20, adim: 5 },
      { anahtar: 'kalinlik', etiket: 'Plaka Kalınlığı', tip: 'mesafe', varsayilan: 12, birim: 'mm', min: 1, adim: 1 },
      { anahtar: 'delikCap', etiket: 'Bulon Delik Çapı', tip: 'mesafe', varsayilan: 18, birim: 'mm', min: 1, adim: 1 },
      { anahtar: 'sutun', etiket: 'Delik Sütun', tip: 'tamsayi', varsayilan: 2, min: 0, max: 20, adim: 1 },
      { anahtar: 'satir', etiket: 'Delik Satır', tip: 'tamsayi', varsayilan: 2, min: 0, max: 20, adim: 1 },
      { anahtar: 'adimX', etiket: 'Yatay Adım', tip: 'mesafe', varsayilan: 80, birim: 'mm', min: 5, adim: 5 },
      { anahtar: 'adimY', etiket: 'Dikey Adım', tip: 'mesafe', varsayilan: 80, birim: 'mm', min: 5, adim: 5 },
      { anahtar: 'kot', etiket: 'Kot (Z)', tip: 'mesafe', varsayilan: 0, birim: 'mm', adim: 10 },
    ],
  },

  // ====================== MARANGOZLUK + MOBİLYA WORKBENCH (çoklu-feature makroları) ======================
  {
    id: 'panel', etiket: 'Pano (Levha)', ikon: 'square outline', workbench: 'marangoz',
    parametreler: [
      { anahtar: 'en', etiket: 'En', tip: 'mesafe', varsayilan: 600, birim: 'mm', min: 10, adim: 10 },
      { anahtar: 'boy', etiket: 'Boy', tip: 'mesafe', varsayilan: 400, birim: 'mm', min: 10, adim: 10 },
      { anahtar: 'kalinlik', etiket: 'Kalınlık', tip: 'mesafe', varsayilan: 18, birim: 'mm', min: 2, adim: 1 },
    ],
  },
  {
    id: 'karkas', etiket: 'Karkas (Gövde)', ikon: 'th large', workbench: 'marangoz',
    parametreler: [
      { anahtar: 'en', etiket: 'En', tip: 'mesafe', varsayilan: 600, birim: 'mm', min: 50, adim: 10 },
      { anahtar: 'boy', etiket: 'Derinlik', tip: 'mesafe', varsayilan: 350, birim: 'mm', min: 50, adim: 10 },
      { anahtar: 'yuk', etiket: 'Yükseklik', tip: 'mesafe', varsayilan: 720, birim: 'mm', min: 50, adim: 10 },
      { anahtar: 'kalinlik', etiket: 'Panel Kalınlığı', tip: 'mesafe', varsayilan: 18, birim: 'mm', min: 6, adim: 1 },
      { anahtar: 'sirtKalinlik', etiket: 'Sırt Kalınlığı', tip: 'mesafe', varsayilan: 6, birim: 'mm', min: 2, adim: 1 },
      { anahtar: 'sirtVar', etiket: 'Sırt Panel', tip: 'boolean', varsayilan: true },
    ],
  },
  {
    id: 'rafliDolap', etiket: 'Raflı Dolap', ikon: 'columns', workbench: 'marangoz',
    parametreler: [
      { anahtar: 'en', etiket: 'En', tip: 'mesafe', varsayilan: 600, birim: 'mm', min: 50, adim: 10 },
      { anahtar: 'boy', etiket: 'Derinlik', tip: 'mesafe', varsayilan: 350, birim: 'mm', min: 50, adim: 10 },
      { anahtar: 'yuk', etiket: 'Yükseklik', tip: 'mesafe', varsayilan: 1800, birim: 'mm', min: 100, adim: 10 },
      { anahtar: 'kalinlik', etiket: 'Panel Kalınlığı', tip: 'mesafe', varsayilan: 18, birim: 'mm', min: 6, adim: 1 },
      { anahtar: 'rafSayisi', etiket: 'Raf Adedi', tip: 'tamsayi', varsayilan: 3, min: 0, max: 30, adim: 1 },
      { anahtar: 'sirtVar', etiket: 'Sırt Panel', tip: 'boolean', varsayilan: true },
    ],
  },
  {
    id: 'kinisliPano', etiket: 'Kinişli Pano (Dado)', ikon: 'minus square outline', workbench: 'marangoz',
    parametreler: [
      { anahtar: 'en', etiket: 'En', tip: 'mesafe', varsayilan: 600, birim: 'mm', min: 20, adim: 10 },
      { anahtar: 'boy', etiket: 'Boy', tip: 'mesafe', varsayilan: 400, birim: 'mm', min: 20, adim: 10 },
      { anahtar: 'kalinlik', etiket: 'Kalınlık', tip: 'mesafe', varsayilan: 18, birim: 'mm', min: 6, adim: 1 },
      { anahtar: 'genislik', etiket: 'Oluk Genişliği', tip: 'mesafe', varsayilan: 18, birim: 'mm', min: 2, adim: 1 },
      { anahtar: 'derinlik', etiket: 'Oluk Derinliği', tip: 'mesafe', varsayilan: 9, birim: 'mm', min: 1, adim: 0.5 },
      { anahtar: 'konum', etiket: 'Oluk Konumu (X)', tip: 'mesafe', varsayilan: 300, birim: 'mm', min: 0, adim: 5 },
    ],
  },
  {
    id: 'kavelaliPano', etiket: 'Kavelalı Pano (Dowel)', ikon: 'ellipsis vertical', workbench: 'marangoz',
    parametreler: [
      { anahtar: 'en', etiket: 'En', tip: 'mesafe', varsayilan: 600, birim: 'mm', min: 20, adim: 10 },
      { anahtar: 'boy', etiket: 'Boy', tip: 'mesafe', varsayilan: 400, birim: 'mm', min: 20, adim: 10 },
      { anahtar: 'kalinlik', etiket: 'Kalınlık', tip: 'mesafe', varsayilan: 18, birim: 'mm', min: 6, adim: 1 },
      { anahtar: 'adet', etiket: 'Kavela Adedi', tip: 'tamsayi', varsayilan: 4, min: 1, max: 50, adim: 1 },
      { anahtar: 'cap', etiket: 'Kavela Çapı', tip: 'mesafe', varsayilan: 8, birim: 'mm', min: 2, adim: 0.5 },
      { anahtar: 'derinlik', etiket: 'Delik Derinliği', tip: 'mesafe', varsayilan: 12, birim: 'mm', min: 2, adim: 1 },
      { anahtar: 'konum', etiket: 'Sıra Konumu (X)', tip: 'mesafe', varsayilan: 300, birim: 'mm', min: 0, adim: 5 },
    ],
  },
  {
    id: 'kapak', etiket: 'Kapak (Çıta+Ayna)', ikon: 'window maximize outline', workbench: 'marangoz',
    parametreler: [
      { anahtar: 'en', etiket: 'Genişlik', tip: 'mesafe', varsayilan: 400, birim: 'mm', min: 50, adim: 10 },
      { anahtar: 'boy', etiket: 'Yükseklik', tip: 'mesafe', varsayilan: 600, birim: 'mm', min: 50, adim: 10 },
      { anahtar: 'kalinlik', etiket: 'Kalınlık', tip: 'mesafe', varsayilan: 20, birim: 'mm', min: 6, adim: 1 },
      { anahtar: 'cita', etiket: 'Çıta Genişliği', tip: 'mesafe', varsayilan: 70, birim: 'mm', min: 20, adim: 5 },
      { anahtar: 'aynaKalinlik', etiket: 'Ayna Kalınlığı', tip: 'mesafe', varsayilan: 8, birim: 'mm', min: 3, adim: 1 },
    ],
  },
  {
    id: 'cekmece', etiket: 'Çekmece', ikon: 'inbox', workbench: 'marangoz',
    parametreler: [
      { anahtar: 'en', etiket: 'En', tip: 'mesafe', varsayilan: 500, birim: 'mm', min: 50, adim: 10 },
      { anahtar: 'boy', etiket: 'Derinlik', tip: 'mesafe', varsayilan: 400, birim: 'mm', min: 50, adim: 10 },
      { anahtar: 'yuk', etiket: 'Yükseklik', tip: 'mesafe', varsayilan: 120, birim: 'mm', min: 30, adim: 5 },
      { anahtar: 'kalinlik', etiket: 'Yan Kalınlığı', tip: 'mesafe', varsayilan: 15, birim: 'mm', min: 6, adim: 1 },
      { anahtar: 'tabanKalinlik', etiket: 'Taban Kalınlığı', tip: 'mesafe', varsayilan: 6, birim: 'mm', min: 2, adim: 1 },
    ],
  },

  // ═══════════════ ZENGİN HAZIR ÜRÜNLER (çarpıcı, tek-tık parametrik) ═══════════════
  // — TESİSAT —
  { id: 'tBoru', etiket: 'T-Boru (Tee)', ikon: 'sitemap', workbench: 'tesisat', parametreler: [
    { anahtar: 'mCap', etiket: 'Çap', tip: 'mesafe', varsayilan: 40, birim: 'mm', min: 6, adim: 2 },
    { anahtar: 'mEtKal', etiket: 'Et Kalınlığı', tip: 'mesafe', varsayilan: 4, birim: 'mm', min: 1, adim: 0.5 },
    { anahtar: 'mUzun', etiket: 'Ana Uzunluk', tip: 'mesafe', varsayilan: 160, birim: 'mm', min: 20, adim: 5 },
    { anahtar: 'mBransUzun', etiket: 'Branş Uzunluğu', tip: 'mesafe', varsayilan: 70, birim: 'mm', min: 10, adim: 5 } ] },
  { id: 'flansliBoru', etiket: 'Flanşlı Boru', ikon: 'dot circle', workbench: 'tesisat', parametreler: [
    { anahtar: 'mCap', etiket: 'Boru Çapı', tip: 'mesafe', varsayilan: 50, birim: 'mm', min: 10, adim: 2 },
    { anahtar: 'mEtKal', etiket: 'Et Kalınlığı', tip: 'mesafe', varsayilan: 5, birim: 'mm', min: 1, adim: 0.5 },
    { anahtar: 'mUzun', etiket: 'Uzunluk', tip: 'mesafe', varsayilan: 140, birim: 'mm', min: 30, adim: 5 },
    { anahtar: 'mFlansCap', etiket: 'Flanş Çapı', tip: 'mesafe', varsayilan: 90, birim: 'mm', min: 20, adim: 5 },
    { anahtar: 'mCivataAdet', etiket: 'Cıvata Adedi', tip: 'tamsayi', varsayilan: 6, min: 3, max: 16, adim: 1 } ] },
  { id: 'reduksiyon', etiket: 'Redüksiyon', ikon: 'filter', workbench: 'tesisat', parametreler: [
    { anahtar: 'mBuyukCap', etiket: 'Büyük Çap', tip: 'mesafe', varsayilan: 60, birim: 'mm', min: 10, adim: 2 },
    { anahtar: 'mKucukCap', etiket: 'Küçük Çap', tip: 'mesafe', varsayilan: 32, birim: 'mm', min: 6, adim: 2 },
    { anahtar: 'mUzun', etiket: 'Uzunluk', tip: 'mesafe', varsayilan: 120, birim: 'mm', min: 20, adim: 5 } ] },
  // — TAKI —
  { id: 'solitaire', etiket: 'Tek Taşlı Yüzük', ikon: 'gem', workbench: 'taki', parametreler: [
    { anahtar: 'mCap', etiket: 'İç Çap (parmak)', tip: 'mesafe', varsayilan: 18, birim: 'mm', min: 12, adim: 0.5 },
    { anahtar: 'mBand', etiket: 'Band Kalınlığı', tip: 'mesafe', varsayilan: 3, birim: 'mm', min: 1, adim: 0.5 },
    { anahtar: 'mUzun', etiket: 'Band Genişliği', tip: 'mesafe', varsayilan: 5, birim: 'mm', min: 2, adim: 0.5 },
    { anahtar: 'mTasCap', etiket: 'Taş Çapı', tip: 'mesafe', varsayilan: 7, birim: 'mm', min: 2, adim: 0.5 },
    { anahtar: 'mProngAdet', etiket: 'Tırnak Adedi', tip: 'tamsayi', varsayilan: 4, min: 3, max: 8, adim: 1 } ] },
  { id: 'bilezik', etiket: 'Bilezik', ikon: 'circle outline', workbench: 'taki', parametreler: [
    { anahtar: 'mCap', etiket: 'İç Çap', tip: 'mesafe', varsayilan: 60, birim: 'mm', min: 40, adim: 1 },
    { anahtar: 'mBand', etiket: 'Kalınlık', tip: 'mesafe', varsayilan: 6, birim: 'mm', min: 1, adim: 0.5 },
    { anahtar: 'mUzun', etiket: 'Genişlik', tip: 'mesafe', varsayilan: 14, birim: 'mm', min: 3, adim: 1 } ] },
  // — ÇELİK —
  { id: 'tabanPlakasi', etiket: 'Bulonlu Taban Plakası', ikon: 'th large', workbench: 'celik', parametreler: [
    { anahtar: 'en', etiket: 'Plaka Boyutu', tip: 'mesafe', varsayilan: 200, birim: 'mm', min: 80, adim: 10 },
    { anahtar: 'kalinlik', etiket: 'Plaka Kalınlığı', tip: 'mesafe', varsayilan: 20, birim: 'mm', min: 5, adim: 1 },
    { anahtar: 'mKolonCap', etiket: 'Kolon Çapı', tip: 'mesafe', varsayilan: 80, birim: 'mm', min: 20, adim: 5 },
    { anahtar: 'mKolonYuk', etiket: 'Kolon Yüksekliği', tip: 'mesafe', varsayilan: 120, birim: 'mm', min: 20, adim: 10 },
    { anahtar: 'mCivataCap', etiket: 'Bulon Çapı', tip: 'mesafe', varsayilan: 18, birim: 'mm', min: 6, adim: 1 } ] },
  { id: 'kafesKiris', etiket: 'Kafes Kiriş (Truss)', ikon: 'indent', workbench: 'celik', parametreler: [
    { anahtar: 'mUzun', etiket: 'Açıklık', tip: 'mesafe', varsayilan: 600, birim: 'mm', min: 100, adim: 20 },
    { anahtar: 'mYuk', etiket: 'Yükseklik', tip: 'mesafe', varsayilan: 120, birim: 'mm', min: 30, adim: 10 },
    { anahtar: 'en', etiket: 'Genişlik', tip: 'mesafe', varsayilan: 40, birim: 'mm', min: 10, adim: 5 },
    { anahtar: 'mDikmeAdet', etiket: 'Dikme Adedi', tip: 'tamsayi', varsayilan: 7, min: 2, max: 20, adim: 1 } ] },
  // — MİMARLIK —
  { id: 'duzMerdiven', etiket: 'Düz Merdiven', ikon: 'sort amount up', workbench: 'insaat', parametreler: [
    { anahtar: 'mBasamakAdet', etiket: 'Basamak Adedi', tip: 'tamsayi', varsayilan: 12, min: 2, max: 40, adim: 1 },
    { anahtar: 'mRihtlik', etiket: 'Rıht (yükseklik)', tip: 'mesafe', varsayilan: 18, birim: 'cm', min: 10, adim: 1 },
    { anahtar: 'mBasis', etiket: 'Basış (derinlik)', tip: 'mesafe', varsayilan: 28, birim: 'cm', min: 20, adim: 1 },
    { anahtar: 'en', etiket: 'Genişlik', tip: 'mesafe', varsayilan: 100, birim: 'cm', min: 60, adim: 5 } ] },
  { id: 'korkuluk', etiket: 'Korkuluk', ikon: 'ellipsis vertical', workbench: 'insaat', parametreler: [
    { anahtar: 'mUzun', etiket: 'Uzunluk', tip: 'mesafe', varsayilan: 300, birim: 'cm', min: 50, adim: 10 },
    { anahtar: 'mYuk', etiket: 'Yükseklik', tip: 'mesafe', varsayilan: 100, birim: 'cm', min: 60, adim: 5 },
    { anahtar: 'mDikmeAdet', etiket: 'Dikme Adedi', tip: 'tamsayi', varsayilan: 8, min: 2, max: 40, adim: 1 } ] },
  { id: 'sutunBaslik', etiket: 'Sütun + Başlık', ikon: 'building', workbench: 'insaat', parametreler: [
    { anahtar: 'mCap', etiket: 'Sütun Çapı', tip: 'mesafe', varsayilan: 50, birim: 'cm', min: 15, adim: 5 },
    { anahtar: 'mYuk', etiket: 'Yükseklik', tip: 'mesafe', varsayilan: 280, birim: 'cm', min: 100, adim: 10 } ] },
  // — MARANGOZ —
  { id: 'masa', etiket: 'Masa', ikon: 'table', workbench: 'marangoz', parametreler: [
    { anahtar: 'en', etiket: 'En', tip: 'mesafe', varsayilan: 1200, birim: 'mm', min: 400, adim: 50 },
    { anahtar: 'boy', etiket: 'Derinlik', tip: 'mesafe', varsayilan: 700, birim: 'mm', min: 300, adim: 50 },
    { anahtar: 'yuk', etiket: 'Yükseklik', tip: 'mesafe', varsayilan: 740, birim: 'mm', min: 300, adim: 10 },
    { anahtar: 'kalinlik', etiket: 'Tabla Kalınlığı', tip: 'mesafe', varsayilan: 30, birim: 'mm', min: 10, adim: 2 } ] },
  { id: 'kitaplik', etiket: 'Kitaplık', ikon: 'book', workbench: 'marangoz', parametreler: [
    { anahtar: 'en', etiket: 'En', tip: 'mesafe', varsayilan: 800, birim: 'mm', min: 300, adim: 50 },
    { anahtar: 'boy', etiket: 'Derinlik', tip: 'mesafe', varsayilan: 300, birim: 'mm', min: 150, adim: 10 },
    { anahtar: 'yuk', etiket: 'Yükseklik', tip: 'mesafe', varsayilan: 1800, birim: 'mm', min: 400, adim: 50 },
    { anahtar: 'mRafSayisi', etiket: 'Raf Sayısı', tip: 'tamsayi', varsayilan: 4, min: 1, max: 12, adim: 1 } ] },
  { id: 'sandalye', etiket: 'Sandalye', ikon: 'chair', workbench: 'marangoz', parametreler: [
    { anahtar: 'en', etiket: 'En', tip: 'mesafe', varsayilan: 420, birim: 'mm', min: 300, adim: 10 },
    { anahtar: 'boy', etiket: 'Derinlik', tip: 'mesafe', varsayilan: 420, birim: 'mm', min: 300, adim: 10 },
    { anahtar: 'yuk', etiket: 'Oturma Yüks.', tip: 'mesafe', varsayilan: 460, birim: 'mm', min: 350, adim: 10 },
    { anahtar: 'mSirtYuk', etiket: 'Sırtlık Yüks.', tip: 'mesafe', varsayilan: 420, birim: 'mm', min: 100, adim: 10 } ] },
  { id: 'sehpa', etiket: 'Yuvarlak Sehpa', ikon: 'circle', workbench: 'marangoz', parametreler: [
    { anahtar: 'mCap', etiket: 'Tabla Çapı', tip: 'mesafe', varsayilan: 600, birim: 'mm', min: 300, adim: 20 },
    { anahtar: 'yuk', etiket: 'Yükseklik', tip: 'mesafe', varsayilan: 450, birim: 'mm', min: 200, adim: 10 },
    { anahtar: 'kalinlik', etiket: 'Tabla Kalınlığı', tip: 'mesafe', varsayilan: 25, birim: 'mm', min: 10, adim: 2 } ] },
];

export const komutBul = (id: string): IKomutTanim | null => FIKO_KOMUTLAR.find(k => k.id === id) ?? null;
